import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const mapSrc =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d667.0233943542772!2d72.80417239518168!3d18.964381213216992!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7ce7567291ec5%3A0xac687e67e7524d41!2sSt.%20Stephen%E2%80%99s%20Catholic%20Church!5e0!3m2!1sen!2sin!4v1760125681302!5m2!1sen!2sin";

  return (
    <footer className="relative bg-gradient-to-b from-amber-50 via-amber-100 to-amber-200 border-t border-amber-100/50">
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 lg:grid-cols-4 gap-10">
        {/* Quick links */}
        <div>
          <h4 className="font-bold text-xl mb-6 bg-gradient-to-r from-amber-700 via-amber-600 to-amber-800 bg-clip-text text-transparent tracking-wide pb-2">
            Quick Links
          </h4>
          <ul className="space-y-2.5 text-sm">
            {[
              ["Home", "/"],
              ["History", "/history"],
              ["Clergy", "/parish/clergy"],
              ["Communities", "/parish/communities"],
              ["Cells & Associations", "/parish/cells"],
              ["Villa Theresa High School", "/religious/villa-theresa"],
              ["Sophia College", "/religious/sophia-college"],
              ["St. Elizabeth Hospital", "/religious/st-elizabeth-hospital"],
              ["Announcements", "/Announcements"],
              ["Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={label}>
                <Link
                  to={to}
                  className="text-gray-700 hover:text-amber-600 transition-colors flex items-center gap-2 group"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 group-hover:bg-amber-600 transition-colors"></span>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Parish Timings */}
        <div>
          <h4 className="font-bold text-xl mb-6 bg-gradient-to-r from-amber-700 via-amber-600 to-amber-800 bg-clip-text text-transparent tracking-wide pb-2">
            Parish Timings
          </h4>
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <svg
                className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <p className="text-sm text-gray-700 leading-relaxed">
                Office Hours:
                <br />
                10 AM – 1 PM (Mon–Sat)
              </p>
            </div>

            <div className="flex items-start gap-3">
              <svg
                className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              <p className="text-sm text-gray-700 leading-relaxed">
                Confessions:
                <br />
                Saturday • 6:15–7:00 PM
              </p>
            </div>
          </div>
        </div>

        {/* Contact Us */}
        <div>
          <h4 className="font-bold text-xl mb-6 bg-gradient-to-r from-amber-700 via-amber-600 to-amber-800 bg-clip-text text-transparent tracking-wide pb-2">
            Contact Us
          </h4>
          <div className="space-y-4">
            <p className="text-sm text-gray-700 leading-relaxed">
              1, L. Jagmohandas Marg,
              <br />
              Cumballa Hill, Mumbai 400036
            </p>
            <p className="text-sm text-gray-700">
              Phone:{" "}
              <a
                href="tel:+912235634667"
                className="hover:text-amber-600 transition-colors"
              >
                +91 22 35634667
              </a>
            </p>
            <p className="text-sm text-gray-700">
              Email:{" "}
              <a
                href="mailto:ststephen1941@gmail.com"
                className="hover:text-amber-600 transition-colors"
              >
                ststephen1941@gmail.com
              </a>
            </p>
          </div>
        </div>

        {/* Map */}
        <div>
          <h4 className="font-bold text-xl mb-6 bg-gradient-to-r from-amber-700 via-amber-600 to-amber-800 bg-clip-text text-transparent tracking-wide pb-2 flex items-center gap-2">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-amber-600"
            >
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            Find Us
          </h4>
          <div className="w-full rounded-xl overflow-hidden shadow-lg border-2 border-amber-100 hover:border-amber-200 transition-colors">
            <iframe
              title="St. Stephen's location"
              src={mapSrc}
              width="100%"
              height="220"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            />
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="relative bg-gradient-to-b from-[#f8d4ab] via-[#e59d7e] to-[#8b4c37] overflow-hidden">
        {/* 🎄 Fairy lights */}
        <div className="fairy-lights">
          {Array.from({ length: 20 }).map((_, i) => (
            <span key={i} className="fairy-light" />
          ))}
        </div>

        <div className="absolute top-0 left-0 w-full h-[12px] bg-gradient-to-b from-[#fff6dc]/80 via-[#ffe3b5]/50 to-transparent blur-[8px] opacity-90"></div>

        <div className="max-w-7xl mx-auto px-6 py-5 relative z-10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
            <div className="text-center md:flex-1">
              <p className="font-medium mb-1 text-[#fffaf3] drop-shadow-sm">
                Copyright © {new Date().getFullYear()} St. Stephen&apos;s Church,
                Cumballa Hill
              </p>
              <p className="text-[#fffaf3]/90 text-xs drop-shadow-sm">
                Designed by Ian Almeida for St. Stephen&apos;s Parish
              </p>
            </div>

            <div className="flex items-center gap-6">
              {/* Instagram */}
              <a
                href="https://www.instagram.com/stephenitesyouth"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="transition-transform transform hover:scale-110"
              >
                <svg
                  className="w-8 h-8"
                  viewBox="0 0 100 100"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <linearGradient
                      id="igGrad"
                      x1="0%"
                      y1="100%"
                      x2="100%"
                      y2="0%"
                    >
                      <stop offset="0%" stopColor="#FCAF45" />
                      <stop offset="25%" stopColor="#FD1D1D" />
                      <stop offset="75%" stopColor="#E1306C" />
                      <stop offset="100%" stopColor="#C13584" />
                    </linearGradient>
                  </defs>
                  <rect
                    x="8"
                    y="8"
                    width="84"
                    height="84"
                    rx="18"
                    fill="none"
                    stroke="url(#igGrad)"
                    strokeWidth="8"
                  />
                  <circle
                    cx="50"
                    cy="50"
                    r="21"
                    fill="none"
                    stroke="url(#igGrad)"
                    strokeWidth="8"
                  />
                  <circle cx="73" cy="27" r="6" fill="url(#igGrad)" />
                </svg>
              </a>

              {/* YouTube */}
              <a
                href="https://www.youtube.com/@st.stephenschurchcumballah8442"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="transition-transform transform hover:scale-110"
              >
                <svg
                  className="w-8 h-8"
                  viewBox="0 0 256 180"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M250.346 28.075c-2.933-11.04-11.627-19.733-22.667-22.667C207.146 0 127.5 0 127.5 0S47.854 0 27.321 5.408c-11.04 2.934-19.734 11.627-22.667 22.667C0 48.608 0 90 0 90s0 41.392 4.654 61.925c2.933 11.04 11.627 19.733 22.667 22.667C47.854 180 127.5 180 127.5 180s79.646 0 100.179-5.408c11.04-2.934 19.734-11.627 22.667-22.667C255 131.392 255 90 255 90s0-41.392-4.654-61.925z"
                    fill="#FF0000"
                  />
                  <path
                    d="M102 128.5L168 90 102 51.5z"
                    fill="#FFFFFF"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
